import * as R from "ramda"

const withDefaultProps = def => C => p => {
  const props = R.mapObjIndexed((v, k) => p[k] === undefined ? v : p[k], def)
  
  return <C {...p} {...props} />
}

export default withDefaultProps
